function SkeletonLoader() {
  return (
    <div className="flex flex-col justify-center w-[100%] h-full mt-6 lg:mt-0">
      <div className="animate-pulse">
        <div className="bg-gray-200 h-4 w-48 rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-full rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-full rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-full rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-full rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-full rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-full rounded mb-6"></div>
        <div className="bg-gray-200 h-4 w-72 rounded"></div>
      </div>
    </div>
  );
}

export default SkeletonLoader;
